export default class DataSourceBase {
  constructor(Vue, id, data) {
    this._id = id
    this.$store = Vue.$store
    this.$router = Vue.$router
    this.$route = Vue.$route

    if (!this.$store) {
      return
    }
    
    /*--- СОЗДАНИЕ STORE ДЛЯ ДАННЫХ ---*/

    // если модуль зарегистрирован - выходим
    if (this.$store.state[this.getStoreModuleName()] !== undefined) {
      return
    }
    // формирование модуля vuex для данных
    let storeModule = {
      namespaced: true,
      state: {
        data: data
      },
      mutations: {
        setData(state, data) {
          state.data = data
        }
      }
    }
    this.$store.registerModule(this.getStoreModuleName(), storeModule)

    /*--- СОЗДАНИЕ STORE ДЛЯ ФИЛЬТРОВ ---*/

    // Если store для фильтров есть - выходим
    if (this.$store.state[this.getFiltersModuleName()] !== undefined) {
      return
    }

    // Формирование модуля vuex для фильтров
    let filtersModule = {
      namespaced: true,
      state: {
        data: data
      },
      mutations: {
        setData(state, data) {
          state.data = data
        }
      }
    }
    this.$store.registerModule(this.getFiltersModuleName(), filtersModule)
  }

  getData() {
    return this.$store.state[this.getStoreModuleName()].data
  }

  getFilters() {
    return this.$store.state[this.getFiltersModuleName()].data
  }

  /** Формирование имени для vuex модуля  */
  getStoreModuleName() {
    return `datasource_${this._id}`
  }

  /** Получение имени vuex модуля для фильтров */
  getFiltersModuleName() {
    return `datasource_filters_${this._id}`
  }
}